import { ACTION_TYPE, DEFAULT_PAGE_SIZE } from '@did/constants'
import { useDasBalanceContext } from '@did/das-app-context'
import { ITrxHistoryListInfo, UseAccountListType } from '@did/das-balance-types'
import Decimal from 'decimal.js'
import { useEffect, useState } from 'react'

export const useAccountList: UseAccountListType = () => {
  const { services, connectedAccount } = useDasBalanceContext()

  const [currPage, setCurrPage] = useState(1)
  const [total, setTotal] = useState(1)
  const [accounts, setAccounts] = useState<ITrxHistoryListInfo[]>([])
  const pages = Math.ceil(total / DEFAULT_PAGE_SIZE)
  const [loading, setLoading] = useState(true)

  const initData = async () => {
    if (!connectedAccount?.address || !connectedAccount.chain?.coinType) {
      setLoading(false)
      return
    }
    try {
      setLoading(true)
      const config = await services.common.config()

      const trxHisRes = await services.account.myTrxHistory({
        key_info: {
          coin_type: connectedAccount.chain?.coinType,
          key: connectedAccount.address
        },
        page: currPage
      })

      if (!trxHisRes || !trxHisRes.list?.length) {
        setAccounts([])
        setTotal(0)
      }

      const _list: ITrxHistoryListInfo[] = []
      trxHisRes.list.forEach((item: ITrxHistoryListInfo) => {
        if (item.action === ACTION_TYPE.sellAccount) {
          _list.push({
            ...item,
            capacity: new Decimal(item.capacity)
              .sub(config.sale_cell_capacity)
              .toString()
          })
          _list.push({
            ...item,
            action: ACTION_TYPE.refundOfDeposit,
            capacity: config.sale_cell_capacity?.toString()
          })
        } else {
          _list.push(item)
        }
      })
      setAccounts(_list)
      setTotal(trxHisRes.total)
    } catch (e: any) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    initData()
  }, [currPage, connectedAccount])

  return {
    currPage,
    setCurrPage,
    accounts,
    loading,
    pages,
    fetchData: initData
  }
}
